import { useNavigation } from '@react-navigation/native'
import { useEffect } from 'react'

import Layout from '../constants/Layout'

export default function useDisableBottomNavigation(forceUse = false) {
  const navigation = useNavigation()

  useEffect(() => {
    if (forceUse || Layout.isSmallDevice) {
      navigation?.getParent()?.setOptions({ tabBarStyle: { display: 'none' } })
    }
  }, [navigation, forceUse, Layout])
}
